import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

const ONBOARDING_LOGO_HEIGHT = 24

export const OnboardingLayoutWrapper = styled.div`
  height: 100%;
  padding: ${Spacing.S40};
`

export const OnboardingLayoutContent = styled.div`
  flex: 1;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
`

export const LogoWrapper = styled.div`
  img,
  figure {
    width: auto;
    height: ${ONBOARDING_LOGO_HEIGHT}px;
  }
`
